import { render, staticRenderFns } from "./ReviewerManage.vue?vue&type=template&id=170412c1&scoped=true&"
import script from "./ReviewerManage.vue?vue&type=script&lang=js&"
export * from "./ReviewerManage.vue?vue&type=script&lang=js&"
import style0 from "./ReviewerManage.vue?vue&type=style&index=0&id=170412c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "170412c1",
  null
  
)

export default component.exports